module.exports = __webpack_public_path__ + "assets/exit.png?8792beb2ac64db44ff3be98d26d72662";